import { render, staticRenderFns } from "./FormTemplateDetail.vue?vue&type=template&id=a7b7c086&scoped=true&"
import script from "./FormTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./FormTemplateDetail.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateDetail.vue?vue&type=style&index=0&id=a7b7c086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b7c086",
  null
  
)

export default component.exports